import { useState, useEffect } from 'react';

/**
 * Hook to detect mobile devices and screen sizes
 */
export const useMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setScreenWidth(width);

      // Mobile: screens smaller than 768px (Tailwind 'md' breakpoint)
      setIsMobile(width < 768);

      // Tablet: screens between 768px and 1024px (Tailwind 'md' to 'lg')
      setIsTablet(width >= 768 && width < 1024);
    };

    // Check on mount
    checkDevice();

    // Listen for resize events
    window.addEventListener('resize', checkDevice);

    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    screenWidth,
  };
};

export default useMobile;
